<template>
  <div>
    <template v-if="category && category.length > 0 && category[0]">
      <div class="caption">
        {{ $t('Options') }} 1<span class="red--text">*</span>
      </div>
      <template v-for="(opt, oindex) in category[0]">
        <product-option-item
          v-model="value"
          :option="opt"
          :key="'option_' + opt.sku + '_' + oindex"
          @onClick="
            option1 = opt
            onChangeOption()
          "
          :isSelected="option1 && option1 == opt"
          @focusOption="focusOption"
          @blurOption="$emit('blurOption')"
        >
          {{ opt.product_title }}
        </product-option-item>
      </template>
    </template>
    <template v-if="category && category.length > 1 && category[1]">
      <div class="caption">
        {{ $t('Options') }} 2<span class="red--text">*</span>
      </div>

      <template v-for="(opt, oindex) in category[1]">
        <product-option-item
          :level="1"
          v-model="value"
          :option="opt"
          :key="'option_sub_' + opt.sku + '_' + oindex"
          @onClick="
            option2 = opt
            onChangeOption()
          "
          :stock="stock"
          :isSelected="option2 && option2 == opt"
          @focusOption="focusOption"
          @blurOption="$emit('blurOption')"
        >
          {{ opt.product_title }}
        </product-option-item>
      </template>
    </template>
    <template v-if="category && category.length > 2 && category[2]">
      <div class="caption">
        {{ $t('Options') }} 3<span class="red--text">*</span>
      </div>

      <template v-for="(opt, oindex) in category[2]">
        <product-option-item
          :level="2"
          v-model="value"
          :option="opt"
          :key="'option_sub1_' + opt.sku + '_' + oindex"
          @onClick="
            option3 = opt
            onChangeOption()
          "
          :stock="stock"
          :isSelected="option3 && option3 == opt"
          @focusOption="focusOption"
          @blurOption="$emit('blurOption')"
        >
          {{ opt.product_title }}
        </product-option-item>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const ProductOptionItem = () => import('./ProductOptionItem')
export default {
  props: ['value', 'category', 'stock'],
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  },
  components: {
    ProductOptionItem
  },
  data() {
    return {
      option1: null,
      option2: null,
      option3: null
    }
  },
  mounted() {
    if (this.value) {
      try {
        let options = this.value.split('/')
        this.option1 = options && options.length > 0 ? options[0] : null
        this.option2 = options && options.length > 1 ? options[1] : null
        this.option3 = options && options.length > 2 ? options[2] : null
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    }
  },
  methods: {
    checkStock(opt) {
      var result = this.stock.find((el) => el[1] == this.option1 + '/' + opt)

      if (result && result[2] !== '0') return true
      else false
    },
    focusOption(payload) {
      this.$emit('focusOption', payload)
    },
    // onChangeOption(type, opt) {
    //   console.log(`type: ${type} , opt: ${opt}`)
    //   this['option' + type] = opt
    //   this.updateOption()
    // },
    onChangeOption() {
      if (this.category.length > 2 && this.category[2]) {
        if (this.option1 && this.option2 && this.option3) {
          let selectedOption = {
            product_price: this.option1.product_price,
            product_sale_net: this.option1.product_sale_net,
            option1: {
              sku: this.option1.sku,
              title: this.option1.product_title
            },
            option2: {
              sku: this.option2.sku,
              title: this.option2.product_title
            },
            option3: {
              sku: this.option3.sku,
              title: this.option3.product_title
            }
          }
          this.$emit(
            'input',
            `${this.option1.sku}/${this.option2.sku}/${this.option3.sku}`
          )
          // this.$emit('changeOption', `${this.option1}/${this.option2}/${this.option3}`)
          this.$emit('changeOption', selectedOption)
        } else {
          this.$emit('input', null)
          this.$emit('changeOption', null)
        }
      } else if (this.category.length > 1 && this.category[1]) {
        if (this.option1 && this.option2) {
          let selectedOption = {
            product_price: this.option1.product_price,
            product_sale_net: this.option1.product_sale_net,
            option1: this.option1.sku,
            option2: this.option2.sku,
            option3: null
          }
          this.$emit('input', `${this.option1.sku}/${this.option2.sku}`)
          // this.$emit('changeOption', `${this.option1}/${this.option2}/${this.option3}`)
          this.$emit('changeOption', selectedOption)
        } else {
          this.$emit('input', null)
          this.$emit('changeOption', null)
        }
      } else {
        let selectedOption = {
          product_price: this.option1 ? this.option1.product_price : null,
          product_sale_net: this.option1 ? this.option1.product_sale_net : null,
          option1: this.option1 ? this.option1 : null,
          option2: null,
          option3: null
        }
        this.$emit('input', this.option1 ? this.option1.sku : null)
        this.$emit('changeOption', selectedOption)
      }
    },
    setdefaultNotEmptyStock() {
      var result = this.stock.filter(
        (el) => el[1].split('/')[0] == this.option1
      )
      result = result.find((el) => el[2] != '0')
      this.option2 = result[1].split('/')[1]
    },
    updateOption() {
      this.$emit('input', this.option1 ? this.option1 : null)
      this.$emit('changeOption', this.option1 ? this.option1 : null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
